import React from 'react';
import { Button } from 'react-bootstrap';

import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import './customizeyourstaycard.scss';

class CustomizeYourStayCard extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const style = { backgroundImage: `url(${this.props.backgroundImage})` };

    const button = !!this.props.buttonLink ? <Button className="welcome-customizeyourstaycard-component__link" bsStyle="link" block href={this.props.buttonLink}>{this.props.translate('welcome.customize_your_stay_card.button')} ></Button> : null;

    return (
      <div className="welcome-customizeyourstaycard-component" style={style}>
        <div className="welcome-customizeyourstaycard-component__overlay"></div>
        <div className="welcome-customizeyourstaycard-component__content">
          <h4 className="welcome-customizeyourstaycard-component__title"><strong>{this.props.title}</strong></h4>
            {button}
        </div>
      </div>
    );
  }
}

CustomizeYourStayCard.displayName = 'PagesWelcomeCustomizeYourStayCard';
CustomizeYourStayCard.propTypes = {};
CustomizeYourStayCard.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale)
  }
};

export default connect(mapStateToProps)(CustomizeYourStayCard);



// WEBPACK FOOTER //
// ./components/pages/welcome/CustomizeYourStayCard.js